import { assetUrl } from '@/config/basePath';

export const appConfig = {
  title: 'AI Core Central',
  description: {
    en: 'Central admin for all Teristimewa AI services',
    id: 'Admin pusat untuk mengelola seluruh layanan AI Teristimewa',
  },
  logo: {
    light: assetUrl('logo-light.svg'),
    dark: assetUrl('logo-dark.svg'),
  },
  defaultLocale: 'en' as const,
  supportedLocales: ['en', 'id'] as const,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  tokenKey: 'auth_token',
  userKey: 'auth_user',
  tenantKey: 'admin_tenant_id',
  themeKey: 'app_theme',
  localeKey: 'app_locale',
  toastPositionKey: 'app_toast_position',
  maxFileSizeMb: 10,
  paginationDefaultPageSize: 10,
  isBoilerplate: false,
  enableDevFeaturesInProduction: false,
} as const;

export type SupportedLocale = (typeof appConfig.supportedLocales)[number];

export function getAppDescription(locale: SupportedLocale): string {
  return appConfig.description[locale];
}
